
export default class InterfaceElement {

    public screen_id?: string = undefined;
    public json?: string = undefined;

    public assign(response: any): InterfaceElement {
        if (response) {
            for (const key in response) {
                if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                    (this as any)[key] = response[key];
                }
            }
        }

        return this;
    }

}
